import datapoints from './datapoints';
import createItemContextsForDeleteStoreUpdate from './helpers/createItemContextsForDeleteStoreUpdate';
import restoreItemService from '../services/restoreItemService';
import deleteItemsStoreUpdate from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import {
    handleServerResponseSuccessAndError,
    onTriageActionFailed,
} from 'owa-mail-triage-action-response-processor';

/**
 * Restore items action
 * @param rowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @return the action response
 */
export default createLegacyActionWithDatapoint('RestoreItem', datapoints.restoreItems)(
    function restoreItems(itemRowKeys: string[], tableViewId: string): Promise<void> {
        const tableView = listViewStore.tableViews.get(tableViewId);
        const folderId = tableView.tableQuery.folderId;
        const itemIdStrings = getRowIdsFromRowKeys(itemRowKeys, tableViewId);
        const itemContexts = createItemContextsForDeleteStoreUpdate(itemIdStrings);

        // 1. Make local update
        deleteItemsStoreUpdate(itemContexts, folderId);

        // 2. Make service call
        const restoreItemsPromise = restoreItemService(itemIdStrings);
        return restoreItemsPromise
            .then(response => {
                return handleServerResponseSuccessAndError(response);
            })
            .catch(error => {
                onTriageActionFailed(tableView);
                return Promise.reject(error);
            });
    }
);
